/**
 * Fabpad PDP — volume combo tiers (Buy 2–5).
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var combosRoot = document.querySelector('[data-pdp-combos]');
    if (!combosRoot) return;

    var configEl = document.querySelector('[data-pdp-combos-config]');
    var variantsEl = document.querySelector('[data-pdp-variants]');
    if (!configEl || !variantsEl) return;

    var config = JSON.parse(configEl.textContent);
    var variants = JSON.parse(variantsEl.textContent);
    var moneyFormat = config.moneyFormat || '{"amount":{{amount}}}';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var selectedTier = null;
    var tiers = combosRoot.querySelectorAll('[data-combo-tier]');

    function formatMoney(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, moneyFormat);
      }
      return '₹' + (cents / 100).toFixed(2);
    }

    function getOptionValue(variant, position) {
      if (position === 1) return variant.option1;
      if (position === 2) return variant.option2;
      return variant.option3;
    }

    function findVariant(size, color, pack) {
      if (config.comboMode === 'size-pack') {
        return variants.find(function (variant) {
          return (
            getOptionValue(variant, config.sizePosition) === size &&
            getOptionValue(variant, config.packPosition) === pack
          );
        });
      }

      return variants.find(function (variant) {
        var matches = true;
        if (config.hasSize) {
          matches = matches && getOptionValue(variant, config.sizePosition) === size;
        }
        if (config.hasColor) {
          matches = matches && getOptionValue(variant, config.colorPosition) === color;
        }
        return matches;
      });
    }

    function qtyOnlyVariant() {
      var variantId = config.defaultVariantId;
      var variant = variants.find(function (item) {
        return String(item.id) === String(variantId);
      });
      if (!variant) variant = variants.find(function (item) { return item && item.available; }) || variants[0];
      return variant || null;
    }

    function getSlotSelections(tier) {
      var items = [];
      var subtotal = 0;
      var compareTotal = 0;
      var allAvailable = true;

      if (config.comboMode === 'qty-only') {
        var qty = parseInt(tier.dataset.qty, 10) || 0;
        var onlyVariant = qtyOnlyVariant();
        if (!onlyVariant || qty < 1) {
          return { items: [], subtotal: 0, compareTotal: 0, allAvailable: false };
        }
        var unitCompare = onlyVariant.compare_at_price && onlyVariant.compare_at_price > onlyVariant.price
          ? onlyVariant.compare_at_price
          : onlyVariant.price;
        return {
          items: [{ id: onlyVariant.id, quantity: qty }],
          subtotal: onlyVariant.price * qty,
          compareTotal: unitCompare * qty,
          allAvailable: !!onlyVariant.available
        };
      }

      var rows = tier.querySelectorAll('.pdp-combos__slot-row');

      rows.forEach(function (row) {
        if (config.comboMode === 'variant') {
          var variantSelect = row.querySelector('[data-combo-variant-select]');
          if (!variantSelect || !variantSelect.value) return;
          var variant = variants.find(function (v) {
            return String(v.id) === String(variantSelect.value);
          });
          if (!variant) return;
          if (!variant.available) allAvailable = false;
          subtotal += variant.price;
          compareTotal += variant.compare_at_price && variant.compare_at_price > variant.price
            ? variant.compare_at_price
            : variant.price;
          items.push({ id: variant.id, quantity: 1 });
          return;
        }

        var sizeSelect = row.querySelector('[data-combo-size-select]');
        var colorSelect = row.querySelector('[data-combo-color-select]');
        var packSelect = row.querySelector('[data-combo-pack-select]');
        var size = sizeSelect ? sizeSelect.value : config.selectedSize;
        var color = colorSelect ? colorSelect.value : config.selectedColor;
        var pack = packSelect ? packSelect.value : config.selectedPack;
        var slotVariant = config.comboMode === 'size-pack'
          ? findVariant(size, null, pack)
          : findVariant(size, color, null);

        if (!slotVariant) {
          allAvailable = false;
          return;
        }

        if (!slotVariant.available) allAvailable = false;

        subtotal += slotVariant.price;
        compareTotal += slotVariant.compare_at_price && slotVariant.compare_at_price > slotVariant.price
          ? slotVariant.compare_at_price
          : slotVariant.price;
        items.push({ id: slotVariant.id, quantity: 1 });
      });

      return {
        items: items,
        subtotal: subtotal,
        compareTotal: compareTotal,
        allAvailable: allAvailable
      };
    }

    function updateTierPricing(tier) {
      var savePct = parseInt(tier.dataset.savePct || '0', 10);
      var data = getSlotSelections(tier);
      var discounted = Math.round(data.subtotal * (100 - savePct) / 100);
      var saveAmount = data.subtotal - discounted;

      var saveEl = tier.querySelector('[data-combo-save]');
      var totalEl = tier.querySelector('[data-combo-total]');
      var compareEl = tier.querySelector('[data-combo-compare]');

      if (saveEl) saveEl.textContent = formatMoney(saveAmount);
      if (totalEl) totalEl.textContent = formatMoney(discounted);
      if (compareEl) {
        if (data.compareTotal > discounted) {
          compareEl.textContent = formatMoney(data.compareTotal);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      return {
        total: discounted,
        compare: data.compareTotal,
        save: saveAmount,
        allAvailable: data.allAvailable
      };
    }

    function setTierState(tier, isSelected) {
      tier.classList.toggle('is-selected', isSelected);
      var panel = tier.querySelector('[data-combo-panel]');
      var trigger = tier.querySelector('[data-combo-trigger]');
      if (panel) panel.hidden = !isSelected;
      if (trigger) {
        trigger.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        trigger.setAttribute('aria-expanded', panel && isSelected ? 'true' : 'false');
      }
    }

    function toggleTier(tier) {
      if (selectedTier === tier) {
        clearTierSelection();
        return;
      }
      selectTier(tier);
    }

    function updateMainAtcState() {
      var mainAtc = document.querySelector('[data-main-atc]');
      var stickyAtcBtn = document.querySelector('[data-sticky-atc-button]');
      var available = !selectedTier || getSlotSelections(selectedTier).allAvailable;

      [mainAtc, stickyAtcBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        btn.classList.toggle('pdp-atc-button--oos', !available);
        if (available) {
          btn.textContent = btn === stickyAtcBtn ? 'Add to cart' : 'Add to cart';
        } else {
          btn.textContent = 'Sold out';
        }
      });
    }

    function selectTier(tier) {
      selectedTier = tier;
      tiers.forEach(function (item) {
        setTierState(item, item === tier);
      });
      updateBuyBoxPricing();
      updateMainAtcState();
      document.dispatchEvent(new CustomEvent('fabpad:combo-change', {
        detail: { tier: tier, active: true }
      }));
    }

    function clearTierSelection() {
      selectedTier = null;
      tiers.forEach(function (item) {
        setTierState(item, false);
      });
      updateMainAtcState();
      document.dispatchEvent(new CustomEvent('fabpad:combo-change', {
        detail: { tier: null, active: false }
      }));
    }

    function updateBuyBoxPricing() {
      if (!selectedTier) return;
      var pricing = updateTierPricing(selectedTier);
      var priceEl = document.querySelector('[data-pdp-price]');
      var compareEl = document.querySelector('[data-pdp-compare]');
      var stickyPrice = document.querySelector('[data-sticky-price]');

      if (priceEl) priceEl.textContent = formatMoney(pricing.total);
      if (stickyPrice) stickyPrice.textContent = formatMoney(pricing.total);
      if (compareEl) {
        if (pricing.compare > pricing.total) {
          compareEl.textContent = formatMoney(pricing.compare);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
    }

    tiers.forEach(function (tier) {
      tier.querySelectorAll('[data-combo-size-select], [data-combo-color-select], [data-combo-pack-select], [data-combo-variant-select]').forEach(function (select) {
        select.addEventListener('change', function () {
          updateTierPricing(tier);
          if (selectedTier === tier) {
            updateBuyBoxPricing();
            updateMainAtcState();
          }
        });
      });

      var trigger = tier.querySelector('[data-combo-trigger]');

      if (trigger) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          toggleTier(tier);
        });

        trigger.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          toggleTier(tier);
        });
      }

      updateTierPricing(tier);
    });

    document.addEventListener('fabpad:variant-change', function (event) {
      var detail = event.detail || {};
      if (detail.size != null && detail.size !== '') config.selectedSize = detail.size;
      if (detail.color != null && detail.color !== '') config.selectedColor = detail.color;
      if (detail.pack != null && detail.pack !== '') config.selectedPack = detail.pack;

      if (detail.variant && detail.variant.id) {
        tiers.forEach(function (tier) {
          tier.querySelectorAll('[data-combo-variant-select]').forEach(function (el) {
            el.value = String(detail.variant.id);
          });
          if (detail.size) {
            tier.querySelectorAll('[data-combo-size-select]').forEach(function (el) {
              el.value = detail.size;
            });
          }
          if (detail.color) {
            tier.querySelectorAll('[data-combo-color-select]').forEach(function (el) {
              el.value = detail.color;
            });
          }
          if (detail.pack) {
            tier.querySelectorAll('[data-combo-pack-select]').forEach(function (el) {
              el.value = detail.pack;
            });
          }
        });
      }

      tiers.forEach(function (tier) {
        updateTierPricing(tier);
      });
      if (selectedTier) {
        updateBuyBoxPricing();
        updateMainAtcState();
      }
    });

    window.FabpadCombos = {
      isActive: function () {
        return !!selectedTier;
      },
      getSelectedTier: function () {
        return selectedTier;
      },
      clearSelection: clearTierSelection,
      getCartItems: function () {
        if (!selectedTier) return [];
        return getSlotSelections(selectedTier).items;
      },
      isAvailable: function () {
        if (!selectedTier) return true;
        return getSlotSelections(selectedTier).allAvailable;
      },
      addToCart: function () {
        if (!selectedTier) return Promise.reject(new Error('No combo selected'));

        var data = getSlotSelections(selectedTier);
        if (!data.items.length || !data.allAvailable) {
          return Promise.reject(new Error('Combo unavailable'));
        }

        var items = data.items.map(function (item) {
          var planInput = document.querySelector('[data-selling-plan]');
          var planId = planInput && parseInt(planInput.value, 10);
          if (planId > 0) {
            return { id: item.id, quantity: item.quantity, selling_plan: planId };
          }
          return item;
        });

        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (res) {
          if (!res.ok) throw new Error('Add failed');
          return res.json();
        });
      }
    };
  });
})();
